export default __webpack_public_path__ + "static/media/NFT.fdde7a5a.jpg";